export default text => text.replace(/<\/?[^>]+(>|$)/g, "");